import React from 'react';

interface AlertMessageProps {
  type: 'error' | 'success' | 'warning';
  message: string;
  show: boolean;
  className?: string;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  type,
  message,
  show,
  className = '',
}) => {
  if (!show || !message) return null;

  const baseClasses = 'border px-4 py-3 rounded-md text-sm';

  const typeClasses = {
    error: 'bg-red-50 border-red-200 text-red-600',
    success: 'bg-green-50 border-green-200 text-green-600',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-600',
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]} ${className}`}>
      {message}
    </div>
  );
};

export default AlertMessage;
